import React, { useState } from "react";
import Timeline, { TodayMarker } from "react-calendar-timeline";

import { useTimeline } from "../../context/TimelineProvider";

import { useTimelineMethods } from "./hooks/hooks";
import useInitEffects from "./hooks/useInitEffects";
import Tooltip from "./components/Tooltip/Tooltip";

import "./style.css";

const CustomGroupRenderer = ({ group }) => {
  return (
    <div
      className="flex items-center justify-between"
      style={{ background: group.status === "available" ? "#fff" : "red" }}
    >
      <p className="mx-2 font-bold">{group.title}</p>
    </div>
  );
};

const CustomTimeline = ({ divisionId }) => {
  const {
    segments,
    groups,
    selectedSegment,
    segmentTooltipData,
    // updateSegment,
  } = useTimeline();

  const {
    handleContextMenu,
    defaultTimeStart,
    defaultTimeEnd,
    canMoveItem,
    handleItemMove,
    defaultTimeRange,
    handleItemSelect,
    handleTimeChange,
    // getProductData,
  } = useTimelineMethods(divisionId);

  // const [lastBackground, setLastBackground] = useState("");

  useInitEffects(divisionId);

  if (!groups.length) {
    return null;
  }

  return (
    <div
      style={{
        width: "70vw",
        minHeight: "400px",
        maxHeight: "calc(100vh - 155px)",
        overflowY: "auto",
        position: "relative",
        borderRight: "solid #ccc 10px",
      }}
      onContextMenu={handleContextMenu}
    >
      <Timeline
        // key={lockedZones.length}
        groups={groups}
        items={segments}
        defaultTimeStart={defaultTimeStart}
        defaultTimeEnd={defaultTimeEnd}
        canMove={canMoveItem}
        onItemMove={handleItemMove}
        onItemSelect={handleItemSelect}
        selected={selectedSegment ? [selectedSegment] : []}
        stackItems={false}
        canResize={false}
        dragSnap={60 * 1000}
        minZoom={defaultTimeRange}
        maxZoom={defaultTimeRange}
        onTimeChange={handleTimeChange}
        itemHeightRatio={1}
        groupRenderer={CustomGroupRenderer}
        itemRenderer={({ item, getItemProps }) => {
          const { onMouseDown, ...restItemProps } = getItemProps({
            style: {
              ...item.style,
              borderRadius: "4px",
              padding: "4px",
              border: "1px solid gray",
              cursor: item.canSelect === false ? "not-allowed" : "pointer",
              height: "50px",
              display: "flex",
              alignItems: "center",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              boxSizing: "border-box",
              userSelect: "none",
            },
          });

          const handleSelectSegment = (e) => {
            if (item.canSelect !== false) {
              // const searchedSegment = segments.find(
              //   (currentSegment) => currentSegment.id === selectedSegment
              // );
              // console.log(lastBackground);
              // if (searchedSegment) {
              //   updateSegment(searchedSegment, {
              //     background: `${lastBackground}`,
              //   });
              //   // getProductData()
              // }

              const background = handleItemSelect(item.id, e);
              // setLastBackground(background);
            }
          };

          return (
            <div {...restItemProps} onClick={handleSelectSegment}>
              <div
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  userSelect: "none",
                  width: "100%",
                  boxSizing: "inherit",
                }}
              >
                {item.order}
              </div>
              <div>{item.title}</div>
            </div>
          );
        }}
      >
        <TodayMarker interval={1000} />
      </Timeline>
      {segmentTooltipData && <Tooltip divisionId={divisionId} />}
    </div>
  );
};

export default CustomTimeline;
